/* eslint-disable react/prop-types */
import React from 'react'
import { Space, Typography, Image } from 'antd'
import { format } from 'date-fns-tz'

import { RefundTableItem } from '../table.common'

const { Text } = Typography

export type RefundTableExpandedRow = (
	record: RefundTableItem,
	index: number,
	indent: number,
	expanded: boolean,
) => React.ReactNode

export const ExpandedRow: RefundTableExpandedRow = ({ certifications, onClickPreview }) => {
	const maxCertCount: number = certifications.filter(
		(certification) => certification.certificatedImage,
	).length

	return (
		<>
			<Space>
				<Space>
					<Text type="secondary">인증 사진</Text>
					<Text>{`${certifications.length} / ${maxCertCount}`}</Text>{' '}
					{/* WARN: 모든 제품의 필요 인증 횟수가 14라고 가정함. 추후에 변경될 수 있음 */}
				</Space>
				<Space>
					<Text type="secondary">인증 시작 날짜 :</Text>
					<Text>{format(certifications[0].certificatedDatetime, 'yyyy.MM.dd')}</Text>
				</Space>
			</Space>

			<div
				style={{
					display: 'flex',
					flexDirection: 'row',
					flexWrap: 'wrap',
					gap: '22px',
					marginTop: '16px',
				}}
			>
				{certifications.map(({ taskNo, certificatedImage, certificatedDatetime }, index) => (
					<div key={taskNo}>
						<Image
							src={certificatedImage}
							alt={`${taskNo}`}
							width={92}
							preview={{ visible: false }}
							onClick={() => {
								onClickPreview(index)
							}}
						/>
						<div style={{ marginTop: '8px' }}>
							<div style={{ fontSize: '12px', lineHeight: '14px', fontWeight: 400 }}>
								{format(certificatedDatetime, 'yyyy-MM-dd')}
							</div>
							<div style={{ fontSize: '12px', lineHeight: '14px', fontWeight: 400 }}>
								{format(certificatedDatetime, 'hh:mm')}
							</div>
						</div>
					</div>
				))}
			</div>
		</>
	)
}
